exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".recommend-recommend-item-1kOP7{cursor:pointer;position:relative;height:80px;width:140px;display:flex;justify-content:space-around}.recommend-recommend-icon-1aIOv{position:absolute;right:6px;top:0}.recommend-recommend-img-2FDUG{outline:1.5px solid rgba(0,0,0,.08)}", ""]);

// Exports
exports.locals = {
	"recommend-item": "recommend-recommend-item-1kOP7",
	"recommend-icon": "recommend-recommend-icon-1aIOv",
	"recommend-img": "recommend-recommend-img-2FDUG"
};